
const DownloadIconSmall = () => {
    return (
        <svg width="15px" height="14px" viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PP---Desktop---Chat-Thread---Charts-and-Graphs---1920-Copy-2" transform="translate(-1075, -204)" stroke="#6C7275" strokeWidth="2">
                    <g id="Group-3" transform="translate(1076, 205)">
                        <path d="M12.484,8.40663048 L12.484,9.52219296 C12.484,10.445391 11.7887615,11.1398722 10.8655635,11.1398722 L1.61843654,11.1398722 C0.694481194,11.1398722 0,10.445391 0,9.52219296 L0,8.40663048" id="Stroke-1"></path>
                        <line x1="6.47336751" y1="7.41890706" x2="6.47336751" y2="0" id="Stroke-3"></line>
                        <polyline id="Stroke-5" points="9.60943858 4.09827212 6.47329177 7.41921 3.33714496 4.09827212"></polyline>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default DownloadIconSmall;
